export default __webpack_public_path__ + "a7719c3b728e85b086e9913eaf8d8c9d.png";